import { render, staticRenderFns } from "./RequestTypeSelector.vue?vue&type=template&id=4a87e044&"
import script from "./RequestTypeSelector.vue?vue&type=script&lang=js&"
export * from "./RequestTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports